import {
  FrameworkAssets,
  FrameworkAssetsProps,
} from "~/pages/compliance/Framework/FrameworkOutlets";

const FrameworkAssetsEntryPage = ({}: FrameworkAssetsProps) => {
  return <FrameworkAssets />;
};

export default FrameworkAssetsEntryPage;
